import { render, staticRenderFns } from "./student.vue?vue&type=template&id=5d0f87f8&"
import script from "./student.vue?vue&type=script&lang=js&"
export * from "./student.vue?vue&type=script&lang=js&"
import style0 from "./student.vue?vue&type=style&index=0&id=5d0f87f8&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0f87f8')) {
      api.createRecord('5d0f87f8', component.options)
    } else {
      api.reload('5d0f87f8', component.options)
    }
    module.hot.accept("./student.vue?vue&type=template&id=5d0f87f8&", function () {
      api.rerender('5d0f87f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/student.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/student.vue
// module id = 7o5F
// module chunks = 0